import { Component, ElementRef, Input, OnChanges, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { Client } from '@df/core/service/client';
import { ScrollService } from '@df/util/service/scroll.service';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
    selector: 'overlay',
    template: '',
    styleUrls: ['overlay.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayComponent implements OnChanges, OnDestroy {
    /**
     * Bool or subject of bool stearing the visiblity
     */
    @Input()
    visible: BehaviorSubject<boolean> | boolean = false;

    /**
     * If scrolling should be blocked
     */
    @Input()
    blockScroll = true;

    /**
     * If is currently visible
     */
    private _visible = false;

    /**
     * Subscription
     */
    private subscription?: Subscription;

    /**
     * Scroll release method
     */
    private scrollRelease?: () => void;

    /**
     * Deps
     */
    constructor(
        private renderer2: Renderer2,
        private elementRef: ElementRef,
        private scrollService: ScrollService,
        private client: Client,
        ref: ChangeDetectorRef
    ) {
        ref.detach();
    }

    /**
     * Input changes listener
     */
    ngOnChanges(changes) {
        if (changes.visible) {
            if (typeof this.visible === 'boolean') {
                this.update(this.visible);
            } else if (this.visible) {
                this.visible.subscribe(value => this.update(value));
            } else {
                this.update(false);
            }
        }

        this.updateScrollBlock();
    }

    /**
     * Cleanup
     */
    ngOnDestroy() {
        this.subscription?.unsubscribe();
        this.releaseScroll();
    }

    /**
     * Update visibility class
     */
    private update(_visible: boolean) {
        if (this._visible !== _visible) {
            this._visible = _visible;
            this._visible
                ? this.renderer2.addClass(this.elementRef.nativeElement, '_visible')
                : this.renderer2.removeClass(this.elementRef.nativeElement, '_visible');
            this.updateScrollBlock();
        }
    }

    /**
     * Syncs status of scroll blocking
     */
    private updateScrollBlock() {
        const shouldBlock = this._visible && this.blockScroll; //  && !this.client.isCms; // if you want this restored then please create exception for off canvas
        if (shouldBlock) {
            if (!this.scrollRelease) {
                this.scrollRelease = this.scrollService.blockScroll();
            }
        } else {
            this.releaseScroll();
        }
    }

    /**
     * Releases the scroll block
     */
    private releaseScroll() {
        if (this.scrollRelease) {
            this.scrollRelease();
            this.scrollRelease = undefined;
        }
    }
}
